import {
    constants,
    getApi,
    deleteApi,
    postApi,
    putApi,
} from "../../helpers/Api/Index";
 
export const addMedicine = (data: any) => {
    return postApi(constants.urls.MEDICINE_ADD, data);
};
 
export const editMedicine = (data: any, id: string) => {
    return putApi(constants.urls.MEDICINE_EDIT + "/" + id, data);
 
};
 
export const listPatientMedicine = (params: string = "") => {
    return getApi(constants.urls.MEDICINE_LIST, params);
 
};
export const deleteMedicine = (id: string) => {
    return deleteApi(constants.urls.MEDICINE_DELETE + "/" + id);
};
 
 
export const getByMedicineId = (id: string) => {
    return getApi(constants.urls.MEDICINE_GETBYID + "/" + id);
};
 
export const rollbackMedicine = (id: string) => {
    return deleteApi(constants.urls.MEDICINE_ROLLBACK + "/" + id);
};
export const deleteMedicineHard = (id: string) => {
    return deleteApi(constants.urls.MEDICINE_DELETE_HARD + "/" + id + "?hard=true");
};
export const bookingMedicineDropdown = () => {
    return getApi(constants.urls.MEDICINE_DROPDOWN).then((res: any) => res.data.map((item: any) => {
        return {
            id: item.id,
            label: item.patient_id
        }
    }))
};
 
export const MedicineDropdown = () => {
    return getApi(constants.urls.MEDICINE_DETAILS_DROPDOWN).then((res: any) => res.map((item: any) => {
        return {
            id: item.id,
            label: item.medicine_name
        }
    }))
};
export const MedicineAllFields = () => {
    return getApi(constants.urls.MEDICINE_DETAILS_DROPDOWN)
};
 
export const MedicineNameDropdown = () => {
    return getApi(constants.urls.MEDICINE_DETAILS_DROPDOWN)
};
 
export const MedicineDiagnosisUpdate = (data: any, id: string) => {
    return putApi(constants.urls.MEDICINE_DIAGNOSIS_UPDATE + "/" + id, data);
 
};
 
export const getStatusValue = async (id: any) => {
    let statusValues: any = await getPayment();
    let value = statusValues.find((x: any) => Number(x.id) === Number(id));
    return value['label'];
}
export const getPayment = () => {
    return new Promise((resolve, reject) => {
 
        resolve([
            {
                id: 0,
                label: "Pending"
            },
            {
                id: 1,
                label: "Completed"
            },
            {
                id: 2,
                label: "Rejected"
            }
        ])
 
    })
}